// extracted by mini-css-extract-plugin
export default {"item":"Faq_item__C7-jC","itemContent":"Faq_itemContent__Vv8k2"};